import React, { useState } from 'react'
import { Link } from 'react-head'

const FONT_DOMAIN = 'https://fonts.googleapis.com'
const FONT_STATIC_DOMAIN = 'https://fonts.gstatic.com'
const FONT_FAMILY =
  '/css?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap'
const FONT_URL = FONT_DOMAIN + FONT_FAMILY

export const GoogleFonts: React.FC = () => {
  const [loadedState, setLoadedState] = useState(false)

  return (
    <>
      <Link rel="preconnect" href={FONT_STATIC_DOMAIN} />
      <Link rel="preconnect" href={FONT_DOMAIN} />
      <Link rel="preload" as="style" href={FONT_URL} />
      <Link
        rel="stylesheet"
        media={loadedState ? '' : 'print'}
        onLoad={() => setLoadedState(true)}
        href={FONT_URL}
      />
      <noscript>
        <Link rel="stylesheet" href={FONT_URL} />
      </noscript>
    </>
  )
}
